/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_Check_In_BtnInputs */



/**
* | output |
* | --- |
* | "Check In" |
*
* @param {Tournament_Check_In_BtnInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_check_in_btn = /** @type {((inputs?: Tournament_Check_In_BtnInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Check_In_BtnInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Pointer")
	if (locale === "es") return /** @type {LocalizedString} */ ("Check-in")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Check-in")
	if (locale === "it") return /** @type {LocalizedString} */ ("Check In")
	return /** @type {LocalizedString} */ ("Check In")
});